import { Button, BackTop, Divider, Form, Input } from 'antd';
import { ArrowLeftOutlined, ArrowRightOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import { useEffect } from 'react';
import Sticky from 'react-sticky-el';
import BtnSave from './BtnSave';
import Editor from '../../../../components/Shared/forms/EditorPrivacy';
import TextBox from '../../Shared/TextBox';

export default function Step2({ ...props }) {
    const { setStep2, editData } = props;
    const { t } = useTranslation(['hr-policy', 'translation']);

    const onNextStep = () => {
        props?.form
            .validateFields()
            .then(() => {
                setStep2(true);
            })
            .catch(() => setStep2(false));
        props.nextStep();
    };

    const onPreviousStep = () => {
        props.previousStep();
    };

    useEffect(() => {
        if (editData) {
            let check = true;
            const allowKey = [
                'hrIntroductionLawfulBasisId',
                'hrIntroductionTitleTh',
                'hrIntroductionTitleEn',
                'hrIntroductionContentTh',
                'hrLawfulBasisTitleTh',
                'hrLawfulBasisTitleEn',
                'hrLawfulBasisContentTh',
            ];
            for (const [key, value] of Object.entries(
                editData?.hrIntroductionLawfulBasis
            )) {
                if (allowKey.includes(key) && !value) {
                    check = false;
                }
            }
            setStep2(check);
        } // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [editData]);

    return (
        <div className="px-4 block_">
            <div className="text-purple-PHX font-semibold text-2xl">
                {t('Introduction and Lawful Basis')}
            </div>
            <div className="text-gray-500 text-tiny">
                {t('policy.desEtc', { ns: 'translation' })}
            </div>
            <Divider />
            <Form
                scrollToFirstError={{
                    behavior: 'smooth',
                    block: 'center',
                }}
                name="hrIntroductionLawfulBasis"
                layout="vertical"
                form={props?.form}
                onValuesChange={(e, allFields) => {
                    let check = true;
                    const allowKey = [
                        'hrIntroductionLawfulBasisId',
                        'hrIntroductionTitleTh',
                        'hrIntroductionTitleEn',
                        'hrIntroductionContentTh',
                        'hrLawfulBasisTitleTh',
                        'hrLawfulBasisTitleEn',
                        'hrLawfulBasisContentTh',
                    ];
                    for (const [key, value] of Object.entries(allFields)) {
                        if (allowKey.includes(key) && !value) {
                            check = false;
                        }
                    }
                    setStep2(check);
                }}
                initialValues={initial}
            >
                <div className="text-purple-PHX font-semibold text-xl">
                    {t('Introduction')}
                </div>
                <Form.Item
                    className="mt-4 mb-4"
                    name={'hrIntroductionTitleTh'}
                    label={
                        <span className="text-sm font-bold">
                            {t('TitleOfTheTopic')} (TH)
                        </span>
                    }
                    rules={[
                        {
                            required: true,
                            message: t('RequiredField'),
                        },
                    ]}
                >
                    <Input
                        size="large"
                        showCount
                        maxLength={200}
                        placeholder={t('PlaceholderTopicTH')}
                    />
                </Form.Item>
                <Form.Item
                    className="mt-4 mb-4"
                    label={
                        <span className="text-sm font-bold">
                            {t('Example Data')}
                        </span>
                    }
                >
                    <div className="bg-[#F4F6FC] rounded-lg h-auto">
                        <TextBox
                            code={`[company_name](“บริษัทฯ” หรือ“เรา”) เล็งเห็นถึงความสำคัญของการคุ้มครองข้อมูลส่วนบุคคล โดยบริษัทฯ จะปฏิบัติตามมาตรการรักษาความมั่นคงปลอดภัยเมื่อมีการเก็บรวบรวม ใช้ และ/หรือเปิดเผยข้อมูลส่วนบุคคล นโยบายความเป็นส่วนตัวของฝ่ายทรัพยากรบุคคลนี้ ("นโยบายความเป็นส่วนตัว") อธิบายเกี่ยวกับวิธีการที่เราใช้ในการเก็บรวบรวม ใช้ และเปิดเผยข้อมูลส่วนบุคคลของของผู้สมัครงาน และผู้เยาว์ ("ท่าน" หรือ "ของท่าน") และบอกกล่าวท่านเกี่ยวกับสิทธิในการปกป้องข้อมูลที่เกี่ยวข้องกับข้อมูลส่วนบุคคลของท่านเกี่ยวกับการขั้นตอนการสรรหาบุคลากรและโครงการต่างๆ\n\nเพื่อวัตถุประสงค์ของนโยบายความเป็นส่วนตัวฉบับนี้ "ข้อมูลส่วนบุคคล" หมายถึง "ข้อมูลใดๆ ที่เกี่ยวข้องกับตัวบุคคลหรือที่ทำให้สามารถระบุตัวบุคคลนั้นได้ ตามที่ระบุด้านล่าง\n\nบริษัทขอสงวนสิทธิในการแก้ไขนโยบายความเป็นส่วนตัวนี้เป็นครั้งคราว ดังนั้น โปรดตรวจสอบเป็นประจำว่านโยบายความเป็นส่วนตัวนี้ได้รับการแก้ไขครั้งล่าสุดเมื่อใด การเปลี่ยนแปลงใดๆ จะมีผลทันทีเมื่อบริษัทเผยแพร่นโยบายความเป็นส่วนตัวที่แก้ไขดังกล่าวลงในเว็บไซต์หรือแอปพลิเคชันของบริษัท บริษัทจะแจ้งให้ท่านทราบหากมีการแก้ไขหรือปรับปรุงที่มีนัยสำคัญ ส่วนกรณีเป็นการแก้ไขเปลี่ยนแปลงที่เป็นการลิดรอนสิทธิของท่านในส่วนของข้อมูลที่ละเอียดอ่อนตามนโยบายความเป็นส่วนตัวฉบับนี้ บริษัทจะดำเนินการเพื่อขอความยินยอมจากท่านก่อน เว้นแต่เป็นกรณีที่กฎหมายกำหนดเป็นอย่างอื่น`}
                        />
                    </div>
                </Form.Item>
                <Form.Item
                    className="mt-4 mb-4"
                    name={'hrIntroductionContentTh'}
                    label={
                        <span className="text-sm font-bold">
                            {t('Content')} (TH)
                        </span>
                    }
                    rules={[
                        {
                            required: true,
                            message: t('RequiredField'),
                        },
                    ]}
                >
                    <Editor
                        size="large"
                        rows={4}
                        placeholder={t('PleaseSpecifyTH')}
                    />
                </Form.Item>
                <Form.Item
                    className="mt-4 mb-4"
                    name={'hrIntroductionTitleEn'}
                    label={
                        <span className="text-sm font-bold">
                            {t('TitleOfTheTopic')} (EN)
                        </span>
                    }
                    rules={[
                        {
                            required: true,
                            message: t('RequiredField'),
                        },
                    ]}
                >
                    <Input
                        size="large"
                        showCount
                        maxLength={200}
                        placeholder={t('PlaceholderTopicEN')}
                    />
                </Form.Item>
                <Form.Item
                    className="mt-4 mb-4"
                    label={
                        <span className="text-sm font-bold">
                            {t('Example Data')}
                        </span>
                    }
                >
                    <div className="bg-[#F4F6FC] rounded-lg h-auto">
                        <TextBox
                            code={`[company_name](the “Company”, “we”, “us”, or “our”) recognizes the importance of the protectionol personal data. We follow security procedures when collecting, using, and/ or disclosing your Personal Data This HR Privacy Policy (““Privacy Policy““) describes how we collect, use and disclose personal data of job applicant, candidates and minors (““you““ or ““your““), and tells you about data protection rights in relation to your Personal Data in connection with recruiting procedures and programs.For the purpose of this HR Privacy Policy, ““Personal Data““ means any information relating to an identified or identifiable natural person as listed below.We reserve the right to modify this HR Privacy Policy from time to time, so please review it frequently to see when this HR Privacy Policy was last revised. Any changes to this HR Privacy Policy will become effective when we post the revised HR Privacy Policy on our website or application. We will provide additional notice of significant updates. In case any modification deprives your rights of Sensitive Data in relation to this HR Privacy Policy, the Company will first obtain your consent, except as otherwise permitted by law.`}
                        />
                    </div>
                </Form.Item>
                <Form.Item
                    className="mt-4 mb-4"
                    name={'hrIntroductionContentEn'}
                    label={
                        <span className="text-sm font-bold">
                            {t('Content')} (EN)
                        </span>
                    }
                >
                    <Editor
                        size="large"
                        rows={4}
                        placeholder={t('PleaseSpecifyEN')}
                    />
                </Form.Item>
                <Divider />
                <div className="text-purple-PHX font-semibold text-xl">
                    {t('Lawful Basis personal data')}
                </div>
                <Form.Item
                    className="mt-4 mb-4"
                    name={'hrLawfulBasisTitleTh'}
                    label={
                        <span className="text-sm font-bold">
                            {t('TitleOfTheTopic')} (TH)
                        </span>
                    }
                    rules={[
                        {
                            required: true,
                            message: t('RequiredField'),
                        },
                    ]}
                >
                    <Input
                        size="large"
                        showCount
                        maxLength={200}
                        placeholder={t('PlaceholderTopicTH')}
                    />
                </Form.Item>
                <Form.Item
                    className="mt-4 mb-4"
                    label={
                        <span className="text-sm font-bold">
                            {t('Example Data')}
                        </span>
                    }
                >
                    <div className="bg-[#F4F6FC] rounded-lg h-auto">
                        <TextBox
                            code={`บริษัทฯ ดำเนินการเก็บรวบรวม ใช้ หรือเปิดเผยข้อมูลส่วนบุคคลของท่าน โดยมีวัตถุประสงค์ภายใต้ฐานในการประมวลผลข้อมูล ดังต่อไปนี้\n- การปฏิบัติตามสัญญา (Contractual Basis) เพื่อการปฏิบัติตามสัญญาที่ท่านเป็นคู่สัญญา เช่น สัญญาจ้างงาน หรือสัญญาอื่นใด หรือเพื่อใช้ในการดำเนินการตามคำขอ/ใบสมัครของท่านก่อนเข้าทำสัญญา ตามแก่กรณี\n- การปฏิบัติตามกฎหมาย (Legal Obligation) เพื่อปฏิบัติหน้าที่ตามที่กฎหมายกำหนด เช่น กฎหมายคุ้มครองแรงงาน กฎหมายประกันสังคม กฎหมายเงินทดแทน กฎหมายแรงงานสัมพันธ์ กฎหมายกองทุนสำรองเลี้ยงชีพ กฎหมายภาษีอากร กฎหมายป้องกันและปราบปรามการฟอกเงิน กฎหมายคอมพิวเตอร์\n- ประโยชน์โดยชอบด้วยกฎหมาย (Legitimate Interest) เพื่อประโยชน์โดยชอบด้วยกฎหมายของบริษัทฯ โดยไม่เกินขอบเขตที่ท่านสามารถคาดหมายได้อย่างสมเหตุสมผล ซึ่งจะไม่ละเมิดสิทธิพื้นฐาน หรือสิทธิ ทางเสรีภาพของท่าน\n- ความยินยอม (Consent) บริษัทฯ จะขอความยินยอมจากท่าน กรณีที่มีกฎหมายกำหนดให้ขอความยินยอม หรือบริษัทฯ ไม่มีเหตุให้ใช้ฐานการประมวลผลข้างต้นเพื่อประมวลผลข้อมูลส่วนบุคคลที่เก็บรวบรวมมาจากท่านได้`}
                        />
                    </div>
                </Form.Item>
                <Form.Item
                    className="mt-4 mb-4"
                    name={'hrLawfulBasisContentTh'}
                    label={
                        <span className="text-sm font-bold">
                            {t('Content')} (TH)
                        </span>
                    }
                    rules={[
                        {
                            required: true,
                            message: t('RequiredField'),
                        },
                    ]}
                >
                    <Editor
                        size="large"
                        rows={4}
                        placeholder={t('PleaseSpecifyTH')}
                    />
                </Form.Item>
                <Form.Item
                    className="mt-4 mb-4"
                    name={'hrLawfulBasisTitleEn'}
                    label={
                        <span className="text-sm font-bold">
                            {t('TitleOfTheTopic')} (EN)
                        </span>
                    }
                    rules={[
                        {
                            required: true,
                            message: t('RequiredField'),
                        },
                    ]}
                >
                    <Input
                        size="large"
                        showCount
                        maxLength={200}
                        placeholder={t('PlaceholderTopicEN')}
                    />
                </Form.Item>
                <Form.Item
                    className="mt-4 mb-4"
                    label={
                        <span className="text-sm font-bold">
                            {t('Example Data')}
                        </span>
                    }
                >
                    <div className="bg-[#F4F6FC] rounded-lg h-auto">
                        <TextBox
                            code={`The company operates by collecting, using or disclosing your personal data for the following purposes, based on the legal grounds for data processing:\n- Contractual Basis: To fulfill the contractual obligations that you have entered into with the company, such as employment contracts, or for the purpose of processing your requests/applications before entering into a contract.\n- Legal Obligation: To comply with legal obligations imposed on the company, such as labor laws, social security laws, compensation laws, employment relationship laws, retirement fund laws, tax laws, anti-money laundering laws, and computer laws.\n- Legitimate Interest: To pursue the legitimate interests of the company, as long as they do not unduly affect your fundamental rights or freedoms, and within the scope of what you can reasonably expect.\n- Consent: The company will seek your consent in cases where it is required by law or where the other legal grounds for processing your personal data do not apply.`}
                        />
                    </div>
                </Form.Item>
                <Form.Item
                    className="mt-4 mb-4"
                    name={'hrLawfulBasisContentEn'}
                    label={
                        <span className="text-sm font-bold">
                            {t('Content')} (EN)
                        </span>
                    }
                >
                    <Editor
                        size="large"
                        rows={4}
                        placeholder={t('PleaseSpecifyEN')}
                    />
                </Form.Item>
                <Sticky
                    mode="bottom"
                    boundaryElement=".block_"
                    stickyClassName="bg-white p-4 shadow h-16 rounded-lg z-50"
                >
                    {props.editMode ? (
                        <BtnSave
                            goToStep={props.goToStep}
                            loading={props.loading}
                        />
                    ) : (
                        <div className="flex items-center">
                            <Button
                                type="default"
                                size="large"
                                onClick={onPreviousStep}
                            >
                                <ArrowLeftOutlined />{' '}
                                {t('policy.PreviousStep', {
                                    ns: 'translation',
                                })}
                            </Button>
                            <Button
                                type="primary"
                                size="large"
                                onClick={onNextStep}
                                className="ml-4"
                            >
                                {t('policy.NextStep', { ns: 'translation' })}{' '}
                                <ArrowRightOutlined />
                            </Button>
                            <div
                                style={{ borderLeft: '1px solid #DBDBDB' }}
                                className="ml-6"
                            >
                                <Button
                                    onClick={props.saveDraft}
                                    className="text-[#1890FF]"
                                    type="link"
                                >
                                    {t('Save Draft')}
                                </Button>
                                <span>{t('to save the latest changes')}</span>
                            </div>
                        </div>
                    )}
                </Sticky>
            </Form>
            <BackTop style={{ zIndex: 100000 }}>
                <div className="flex items-center justify-center" style={style}>
                    <svg
                        width="16"
                        height="16"
                        viewBox="0 0 16 16"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path
                            d="M8.76395 15.232L8.76395 3.47773L14.8711 10.513C14.9695 10.6255 15.1523 10.5572 15.1523 10.4085L15.1523 8.63064C15.1523 8.55229 15.1242 8.47796 15.074 8.4197L8.48672 0.827956C8.42645 0.758424 8.35193 0.70266 8.26823 0.664442C8.18452 0.626224 8.09358 0.606445 8.00156 0.606445C7.90954 0.606445 7.8186 0.626224 7.7349 0.664442C7.65119 0.70266 7.57668 0.758424 7.51641 0.827956L0.888949 8.46389C0.862833 8.49403 0.848771 8.53019 0.848771 8.56836L0.848771 10.4065C0.848771 10.5552 1.03359 10.6235 1.13002 10.511L7.23716 3.47773L7.23716 15.232C7.23716 15.3204 7.30949 15.3927 7.39788 15.3927L8.60324 15.3927C8.69163 15.3927 8.76395 15.3204 8.76395 15.232Z"
                            fill="white"
                        />
                    </svg>
                </div>
            </BackTop>
        </div>
    );
}

const style = {
    height: 40,
    width: 40,
    lineHeight: '40px',
    borderRadius: 4,
    backgroundColor: '#7B67FB',
    color: '#fff',
    textAlign: 'center',
    fontSize: 14,
};

const initial = {
    hrIntroductionLawfulBasisId: null,
    hrIntroductionTitleTh: 'บทนำ',
    hrIntroductionTitleEn: 'Introduction',
    hrIntroductionContentTh: '',
    hrIntroductionContentEn: '',
    hrIntroductionIsDisplay: true,
    hrLawfulBasisTitleTh: 'ฐานกฎหมายในการประมวลผลข้อมูลส่วนบุคคล',
    hrLawfulBasisTitleEn: 'Lawful basis for processing personal data',
    hrLawfulBasisContentTh: '',
    hrLawfulBasisContentEn: '',
    hrLawfulBasisIsDisplay: true,
};
